import type { FetchRequestArgs } from '../../utils';
import { fetchRequest } from '../../utils';

export const readWorkspacesByOrganization = async <
  T extends Record<string, unknown>,
>({
  organizationId,
  headers,
  archived = false,
  domain,
  query,
  signal,
}: FetchRequestArgs & {
  organizationId: string;
  archived?: boolean;
}): Promise<ReturnType<typeof fetchRequest>> =>
  fetchRequest<T>({
    domain,
    endpoint: `/v2/messaging/organization/${organizationId}/workspaces`,
    headers,
    query: {
      ...query,
      ...(archived ? { includes_inactive: true } : {}),
    },
    signal,
  });
